module.exports = __webpack_public_path__ + "static/purchasing-a-home-landscape-a41f6c65c161c1936407b3a1b9257e2e.jpg";